import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  user_id: number = 0;
  username = '';

  constructor() { }

  setUser(user_id: number, username: string) {
    this.user_id = user_id;
    this.username = username;
  }

  resetUser() {
    this.user_id = 0;
    this.username = '';
  }
}
